import { Component, ElementRef, ViewChild, OnInit, Compiler} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { GridOptions } from "ag-grid";
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import * as XLSX from 'xlsx';
declare var $: any;
interface dropdownTemplate {
  name: string;
  value: string;
}
@Component({
  selector: 'd2z-transvirtual-remap',
  templateUrl: './transvirtual-remap.component.html',
  styleUrls: ['./transvirtual-remap.component.css']
})
export class TransvirtualRemapComponent implements OnInit{
  public importList = [];
  public articleList = [];
  FileArticle = ['ArticleID'];


  manifestNumber: string;
  arrayBuffer:any;
  file:File;
  errorMsg: string;
  show: Boolean;
  ReferenceFlag; Boolean;
  ArticleFlag: Boolean;
  successMsg: String;
  userName: String;
  system: String;
  role_id: String;
   gridOptions: GridOptions;
   articlegridOptions:GridOptions;
   autoGroupColumnDef;
   rowGroupPanelShow;
   rowData: any[];
   rowDataArticle: any[];
  
   defaultColDef;
   shipmentScanForm: FormGroup;
  exportTypeDropdown: dropdownTemplate[];  
  serviceTypeDropdown: dropdownTemplate[];  
  selectedExportType: dropdownTemplate;
  selectedServiceType:dropdownTemplate;
  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    public trackingDataService : TrackingDataService,
    private spinner: NgxSpinnerService,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.show = false;
    this.ReferenceFlag =true;

    this.shipmentScanForm = new FormGroup({
      referenceNumber: new FormControl(),
    });
    this.articlegridOptions = <GridOptions>{ rowSelection: "multiple" };
    this.articlegridOptions.columnDefs = [
      {
        headerName: "Reference Number",
        field: "articleid",
        width: 500,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      }
    ];
    this.autoGroupColumnDef = {
      headerCheckboxSelection: true,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: { checkbox: true }
    };      
    this.rowGroupPanelShow = "always";
    this.defaultColDef = {
      editable: true
    };
  }

  ngOnInit() {
      this.system = document.location.hostname.includes("speedcouriers.com.au") == true ? "Speed Couriers" :"D2Z";
      this.getLoginDetails();
       this.exportTypeDropdown = [
       
       // { "name": "TV JPD", "value": "32" },
        { "name": "TV ALL", "value": "7" },
        { "name": "TV BEN", "value": "8" },
        { "name": "TV CAL", "value": "9" },
       // { "name": "TV GIP", "value": "10" },
       // { "name": "TV MAC", "value": "11" },
        { "name": "TV SEN", "value": "12" },
        { "name": "TV MLD", "value": "18" },
        { "name": "TV SWH", "value": "19" },
        { "name": "TV YVT", "value": "20" },
        { "name": "TV D2Z", "value": "21" },
        { "name": "TV WBL", "value": "63" },
        //{ "name": "TV GPC", "value": "22" },
        //{ "name": "TV AUSF", "value": "30" },
        { "name": "GIPNG", "value": "59" },
        //{ "name": "TV ZTO", "value": "34" },
        { "name": "D2ZNG", "value": "47" },
        { "name": "BENNG", "value": "53" },
        { "name": "LME", "value": "33" },
        //{ "name": "RPD", "value": "27" },
        { "name": "FAST VIC", "value": "3" },
        { "name": "TOLL", "value": "23" },
        { "name": "POST", "value": "5" },
        { "name": "EXPRESS POST", "value": "29" },
        { "name": "PFL", "value": "1" },
        { "name": "HEY", "value": "64" },
      ];

        this.serviceTypeDropdown = [
          { "name": "VC1", "value": "VC1" },
          { "name": "VC2", "value": "VC2" },
          { "name": "VM1", "value": "VM1" },
          { "name": "RES", "value": "RES" }
]

      this.selectedExportType = this.exportTypeDropdown[0];
      this.selectedServiceType = this.serviceTypeDropdown[0];
  };


  getLoginDetails(){
    if(this.consigmentUploadService.userMessage != undefined){
      this.userName = this.consigmentUploadService.userMessage.userName;
      this.role_id = this.consigmentUploadService.userMessage.role_Id;
    }
  };
  
  incomingfile(event) {
    this.rowDataArticle =[];
    this.file = event.target.files[0]; 
    this.fileUpload();
  };

  fileUpload(){
    var worksheet;
      this.errorMsg = null;
      let fileReader = new FileReader();
      this.importList= [];
      this.articleList=[];
      fileReader.readAsText(this.file);
      let referenceNumber = 'referenceNumber';
      let articleid = 'articleid';
      fileReader.onload = (e) => {
          this.arrayBuffer = fileReader.result;
          console.log(this.arrayBuffer)
            //var data = new Uint8Array(this.arrayBuffer);
            var data  = this.getRecordsFromCSV((this.arrayBuffer).split(/\r\n/));
            console.log(data);
            this.rowDataArticle = data;
          
        }
  };

  getRecordsFromCSV(csvRecordsArray:any){
    let csvArr = [];
    for (let i = 0; i < csvRecordsArray.length; i++) {
      let curruntRecord = (csvRecordsArray[i]).split(',');
      var json = {
        "articleid":curruntRecord[0]
      }
        csvArr.push(json);
      }
      return csvArr;
  }
  refresh(){
    this.rowDataArticle=[];
  }

scanToRemap(){
  this.errorMsg = null;
  this.successMsg = '';
  var referenceNumberData = this.shipmentScanForm.value.referenceNumber.split("\n");
  var refrenceNumList = [];
  for (var labelValue in referenceNumberData) {
        var labelObj = referenceNumberData[labelValue];
       
        refrenceNumList.push(labelObj)
  }
  this.spinner.show();
        console.log(refrenceNumList)
    
       
        this.trackingDataService.remapTransvirtual(refrenceNumList,this.selectedExportType.value, (resp) => {
          this.spinner.hide();
          if(resp.error){
            this.successMsg = resp.error.errorDetails;
            $('#allocateShipmentModal').modal('show');
          }else{
            this.successMsg = 'Remapped Successfully';
            $('#allocateShipmentModal').modal('show');
          }
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
        
}
  remapFromFile(){
    this.errorMsg = null;
    this.successMsg = '';

   var selectedRows = this.articlegridOptions.api.getSelectedRows();
   var select = "Article";
   var refrenceNumList = [];
    for (var labelValue in selectedRows) {
          var labelObj = selectedRows[labelValue];
         
          refrenceNumList.push(labelObj.articleid)
    }
     

   
    if(selectedRows.length == 0){
      this.errorMsg = "**Please select the below records to allocate the shipment";
    }
    if(selectedRows.length > 0 && this.errorMsg == null ){
        this.spinner.show();
        console.log(refrenceNumList)
    
       
        this.trackingDataService.remapTransvirtual(refrenceNumList,this.selectedExportType.value, (resp) => {
          this.spinner.hide();
          if(resp.error){
            this.successMsg = resp.error.errorDetails;
            $('#allocateShipmentModal').modal('show');
          }else{
            this.successMsg = 'Remapped Successfully';
            $('#allocateShipmentModal').modal('show');
          }
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
        
    }
  };

 

 onSelectionArticleChange() {
    var selectedRows = this.articlegridOptions.api.getSelectedRows();
    this.errorMsg = null;
  };
}



// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/transvirtual-remap/transvirtual-remap.component.ts